import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
  Panel,
  IconButton,
  Icon,
  Message,
  Form,
  Row,
  Table,
  Uploader,
  Modal,
  Button,
  ButtonGroup,
} from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { startLoading, doneLoading } from '../../../utils/loading'
import { getSchemaSidebar } from '../../../redux/actions/sidebar'
import {
  saveActionPlan,
  updateActionPlan,
  uploadFilesActionPlan,
  deleteFilesActionPlan,
  getFilesActionPlan,
  changeAttachmentActionPlanSeqNo,
} from '../../../redux/actions/objectiveGoal'
import ButtonPanel from '../../ButtonPanel'
import CKEditor from 'ckeditor4-react'
import { getMaxLengthData, isSupportFileType, isValidators } from '../../../utils/ValidatorUtils'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'
import ShowLimitLength from '../../../components/utils/ShowLimitLength'
import TooltipButton from '../../../components/buttons/TooltipButton'

export default function ActionPlanWidget(props) {
  const { Column, HeaderCell, Cell } = Table
  const { showCommandButton, schema, isEdit, onChangeIsEdit } = props
  const [fileList, setFileList] = useState([])
  const [uploadfileList, setUploadfileList] = useState([])
  const [deleteFileId, setDeleteFileId] = useState()
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(schema)

  const [insertFileToContenErr, setInsertFileToContenErr] = useState()
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [fileTypeError, setFileTypeError] = useState(false)
  const [isOverSize, setIsOverSize] = useState(false)
  const [isNotSupportType, setIsNotSupportType] = useState(false)
  const [mapFileData, setMapFileData] = useState([])

  const [loading, setLoading] = useState(false)
  const maxLength = getMaxLengthData(schema.editorData?.validators)?.value
  const [textLength, setTextLength] = useState(schema.editorData?.value?.length || 0)
  const [editorData, setEditorData] = useState()

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const defaultSupportType = '.jpg, .jpeg, .png'
  const defaultMaxFileSize = 5

  useEffect(() => {
    var data = formSchema.editorData.value

    formSchema?.mapFileData?.map((item) => {
      if (item.link != null) {
        let link = `<a href="${item.link}" target="_blank"> ${item.key
          .replace('[[', '')
          .replace(']]', '')} </a>`
        data = data.replace(item.key, link)
      }
    })

    setEditorData(data)
  }, [formSchema])

  useEffect(() => {
    // setSchema(schema)
    setFileList(schema.fileList ? schema.fileList : [])
    setMapFileData(schema.mapFileData ? schema.mapFileData : [])
    setValue('mapFileData', schema.mapFileData ? schema.mapFileData : [])
  }, [schema])

  const handleCallService = async (id, request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        response = await updateActionPlan(id, request)
      } else {
        response = await saveActionPlan(id, request)
      }

      if (response) {
        onChangeIsEdit(false)
        setFormSchema(response)
        await dispatch(getSchemaSidebar(id))
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let request = {
      id: formSchema.id,
      projectVersionId: projectId,
      value: data.editorData,
      mapFileData: [...data.mapFileData],
    }

    handleCallService(projectId, request)
  }

  const onEditorChange = (evt) => {
    const data = evt.editor.getData()
    const text = evt.editor.document.getBody().getText()

    if (data.length > 0) {
      setValue(schema.editorData.name, data)
      clearErrors(schema.editorData.name)
      setTextLength(text.length)
    } else {
      setValue(schema.editorData.name)
      setTextLength(0)
    }
  }

  const onUpload = () => {
    console.log('onUpload')

    var formData = new FormData()

    uploadfileList?.forEach((element) => {
      formData.append('files', element.blobFile)
    })

    handleUpload(formData)
  }

  const handleUpload = async (request) => {
    startLoading()
    setLoading(true)
    setIsUploadErr()
    try {
      console.log('upload')
      const response = await uploadFilesActionPlan(projectId, request)

      console.log('response', response)
      if (response) {
        let _schema = schema
        _schema.fileList = response
        // setSchema(_schema)
        setFileList(response)
        setUploadfileList([])
        setIsUploadErr(false)
      } else {
        setIsUploadErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsUploadErr(true)
    }
    setLoading(false)
    doneLoading()
  }

  const handleDelete = async (fileId) => {
    startLoading()
    setLoading(true)
    setIsDeleteError()
    try {
      console.log('call delete.')
      const status = await deleteFilesActionPlan(projectId, fileId)
      if (status === 200) {
        console.log('call get.')
        const response = await getFilesActionPlan(projectId)
        console.log('result', response)
        // let _schema = schema
        // _schema.fileList = response
        reMapFileDataAndEditer(fileId)
        // setSchema(_schema)
        setFileList(response)
        setIsDeleteError(false)
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setLoading(false)
    doneLoading()
  }

  const reMapFileDataAndEditer = (fileId) => {
    var data = getValues(schema.editorData.name)

    let mapFileList = [...mapFileData]

    var key

    mapFileData.forEach((item, index) => {
      if (item.id.includes(fileId)) {
        key = item.key
        mapFileList.splice(index, 1)
        return
      }
    })

    if (key) {
      var text = key.substring(2, key.length - 2)
      var res = data.replace(key, text)
      setMapFileData(mapFileList)
      setValue('mapFileData', mapFileList)
      setValue(schema.editorData.name, res)
    }
  }

  const handleInsetFileToContent = (file) => {
    setInsertFileToContenErr()

    var editor
    for (var instanceName in CKEDITOR.instances) {
      editor = CKEDITOR.instances[instanceName]
    }
    var selectText = editor.getSelection().getSelectedText()

    if (selectText.trim().length > 0) {
      if (selectText.includes('[') || selectText.includes(']')) {
        setInsertFileToContenErr(`ไม่สามารถใช้ '[' หรือ ']' เป็นข้อความเชื่อมไฟล์`)
      } else {
        let key = '[[' + selectText + ']]'
        let mapPath = [...mapFileData]
        let duplicate = false
        mapPath.forEach((item) => {
          if (key == item.key) {
            duplicate = true
          }
        })

        if (duplicate) {
          setInsertFileToContenErr(
            `ข้อความ '${selectText}' มีการใช้งานไปแล้ว ไม่สามารถใช้ข้อความเดิมซ้ำ`
          )
        } else {
          var obj = { id: file.id, key: key }

          mapPath.push(obj)
          // console.log('mapPath', mapPath)
          setMapFileData(mapPath)
          setValue('mapFileData', mapPath)

          editor.insertHtml(` ${key} `)
        }
      }
    } else {
      setInsertFileToContenErr(`กรุณาเลือกข้อความที่ต้องการแทรกไฟล์`)
    }
  }

  const onChangSeqNo = async (data, seqNo) => {
    startLoading()
    // setIsLoading(true)
    setIsUploadErr()
    try {
      // console.log('onChangSeqNo')
      const response = await changeAttachmentActionPlanSeqNo(projectId, data.id, seqNo)
      console.log('onChangSeqNo response', response)

      if (response) {
        setFileList(response)
      } else {
        setIsUploadErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsUploadErr(true)
    }
    // setIsLoading(false)
    doneLoading()
  }

  const ActionsPlanFormEdit = (
    <>
      <Panel>
        {/* {formSchema.description && (
          <Row style={{ marginTop: 10 }}>
            <CustomIconMessageInfo contents={formSchema.description} />
          </Row>
        )} */}

        {formSchema.description && <CustomAlertMessageInfo contents={schema.description} />}

        {formSchema.message && (
          <Row style={{ marginTop: 10 }}>
            {formSchema.message.map((item, index) => {
              return (
                <Message showIcon type={item.type} description={item.description} key={index} />
              )
            })}
          </Row>
        )}

        <Form fluid style={{ marginTop: 10 }}>
          <Controller
            key={'mapFileData'}
            name={'mapFileData'}
            control={control}
            defaultValue={mapFileData}
          />

          <Row style={{ marginTop: 10 }}>
            {formSchema.editorData.description && (
              <CustomIconMessageInfo contents={formSchema.editorData.description} />
            )}

            <Controller
              key={formSchema.editorData.name}
              name={formSchema.editorData.name}
              control={control}
              rules={isValidators(formSchema.editorData.validators)}
              defaultValue={formSchema.editorData.value}
              render={(props) => {
                return (
                  <CKEditor
                    key="editorData"
                    name="editorData"
                    data={props.value}
                    style={{ marginTop: 10 }}
                    config={{
                      versionCheck: false,
                      toolbar: [['Bold', 'Italic', 'Maximize']],
                      contentsCss: [
                        'https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;600&display=swap',
                        'body { font-size: "1rem"; font-family: "Sarabun", sans-serif; }',
                      ],
                    }}
                    onChange={onEditorChange}
                  />
                )
              }}
            />
          </Row>
          <ShowLimitLength textLength={textLength} maxLength={maxLength} />
        </Form>

        {insertFileToContenErr && (
          <Row style={{ marginTop: 10 }}>
            <Message showIcon type="error" description={insertFileToContenErr} />
          </Row>
        )}

        {isDeleteError && (
          <Row style={{ marginTop: 10 }}>
            <Message showIcon type="error" description={`ลบไฟล์ไม่สำเร็จ`} />
          </Row>
        )}

        <Row style={{ marginTop: 10 }}>
          <Table autoHeight={fileList.length < 5} height={300} wordWrap data={fileList}>
            <Column width={100} align="center" fixed>
              <HeaderCell>ไฟล์ที่</HeaderCell>
              <Cell>
                {(_, index) => {
                  return index + 1
                }}
              </Cell>
            </Column>
            <Column width={100} align="center" fixed>
              <HeaderCell>จัดลำดับ</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  return (
                    <ButtonGroup>
                      {rowData?.isDownSeqNo && (
                        <TooltipButton
                          icon="arrow-circle-up"
                          tooltip={`เลื่อนขึ้น`}
                          disabled={loading}
                          onClick={(e) => onChangSeqNo(rowData, rowData.seqNo - 1)}
                        ></TooltipButton>
                      )}
                      {rowData?.isUpSeqNo && (
                        <TooltipButton
                          icon="arrow-circle-down"
                          tooltip={`เลื่อนลง`}
                          disabled={loading}
                          onClick={(e) => onChangSeqNo(rowData, rowData.seqNo + 1)}
                        ></TooltipButton>
                      )}
                    </ButtonGroup>
                  )
                }}
              </Cell>
            </Column>
            <Column flexGrow={1} fixed>
              <HeaderCell>ชื่อไฟล์</HeaderCell>
              <Cell dataKey="name" />
            </Column>
            <Column width={160} align="center" fixed="right">
              <HeaderCell>แทรกไฟล์ไปยังเนื้อหา</HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        icon={<Icon icon="toggle-up" className="bt-gost-icon-radius" />}
                        onClick={(e) => handleInsetFileToContent(rowData)}
                      />
                    </ButtonGroup>
                  )
                }}
              </Cell>
            </Column>
            <Column width={150} align="center" fixed="right">
              <HeaderCell></HeaderCell>

              <Cell>
                {(rowData, index) => {
                  return (
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-cancel"
                        icon={<Icon icon="trash-o" className="bt-gost-icon-radius-cancel" />}
                        onClick={(e) => setDeleteFileId(rowData.id)}
                      />
                    </ButtonGroup>
                  )
                }}
              </Cell>
            </Column>
          </Table>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <p>แนบไฟล์</p>
          <Message
            showIcon
            type="info"
            description={`ชนิดที่รองรับ : ${
              schema?.fileType || defaultSupportType
            } ${`, ขนาดไฟล์ไม่เกิน ${schema?.fileSize || defaultMaxFileSize} MB`}`}
            //description="ชนิดที่รองรับ : .jpg, .jpeg, .png,  ขนาดไฟล์ไม่เกิน 5 MB"
            style={{ marginBottom: 10 }}
          />

          {fileTypeError && (
            <Message
              style={{ marginTop: 10, marginBottom: 10 }}
              closable
              onClose={() => {
                setFileTypeError(false)
              }}
              showIcon
              type="error"
              // description={`อัพโหลดไฟล์ได้เฉพาะชนิดที่รองรับเท่านั้น *** ชนิดที่รองรับ : ${
              //   schema?.fileType || defaultSupportType
              // } ${`*** , ขนาดไฟล์ไม่เกิน ${schema?.fileSize || defaultMaxFileSize} MB`}`}
              description={`${
                isNotSupportType
                  ? `อัพโหลดไฟล์ได้เฉพาะชนิดที่รองรับเท่านั้น *** ชนิดที่รองรับ ${
                      schema.fileType || defaultSupportType
                    } ***`
                  : ''
              }  ${isOverSize ? ` ขนาดไฟล์เกิน ${schema.fileSize || defaultMaxFileSize} MB ` : ''}`}
            />
          )}

          <Uploader
            autoUpload={false}
            listType="picture-text"
            fileList={uploadfileList}
            onChange={(files) => {
              let file = files[files.length - 1]

              let isSupportSize =
                file?.blobFile.size <= (schema?.fileSize || defaultMaxFileSize) * 1024 * 1024
              let isSupportType = isSupportFileType(
                file?.blobFile.type,
                schema?.reviewFile?.fileType || defaultSupportType
              )
              setIsOverSize(!isSupportSize)

              setIsNotSupportType(!isSupportType)

              if (!file || (isSupportType && isSupportSize)) {
                setUploadfileList(files)
                setFileTypeError(false)
              } else {
                files.splice(files.length - 1, 1)
                setUploadfileList(uploadfileList)
                setFileTypeError(true)
              }
            }}
            draggable
            accept={defaultSupportType}
          >
            <div style={{ lineHeight: '100px' }}>
              <Icon size="4x" icon="upload2" />
              <small
                style={{
                  marginTop: '-70px',
                  display: 'block',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                }}
              >
                คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
              </small>
            </div>
          </Uploader>
        </Row>

        {isUploadErr && (
          <Row style={{ marginTop: 10 }}>
            <Message showIcon type="error" description={`อัพโหลดไฟล์ไม่สำเร็จ`} />
          </Row>
        )}

        {uploadfileList?.length > 0 && (
          <Row style={{ marginTop: 10 }}>
            <IconButton
              appearance="ghost"
              icon={<Icon appearance="ghost" icon="upload2" className="bt-gost-icon-radius" />}
              onClick={(e) => onUpload()}
              style={{ marginRight: 5 }}
              disabled={loading}
            >
              {`อัพโหลด`}
            </IconButton>
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-cancel"
              icon={
                <Icon appearance="ghost" icon={'close'} className="bt-gost-icon-radius-cancel" />
              }
              onClick={(e) => {
                setUploadfileList([])
                setIsUploadErr(false)
                setIsDeleteError(false)
                setFileTypeError(false)
              }}
              style={{ marginRight: 5 }}
              disabled={loading}
            >
              {`ยกเลิก`}
            </IconButton>
          </Row>
        )}
      </Panel>

      <Modal
        show={deleteFileId ? true : false}
        onHide={(e) => {
          setDeleteFileId('')
        }}
      >
        <Modal.Header>
          <Modal.Title>ยืนยันการลบ</Modal.Title>
        </Modal.Header>
        <Modal.Body>{'ยืนยันการลบไฟล์'}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={(e) => {
              handleDelete(deleteFileId)
              setDeleteFileId('')
            }}
            appearance="primary"
          >
            ลบ
          </Button>
          <Button
            onClick={(e) => {
              setDeleteFileId('')
            }}
            appearance="subtle"
          >
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      {/* {isEdit && showCommandButton ? (
        ActionsPlanFormEdit
      ) : (
        <div>
          {formSchema.id == null && <div>-ไม่ระบุ-</div>}
          <div dangerouslySetInnerHTML={{ __html: formSchema.editorData.value }} />
        </div>
      )} */}

      {isEdit && showCommandButton ? (
        ActionsPlanFormEdit
      ) : editorData ? (
        <div style={{ wordWrap: 'break-word' }} dangerouslySetInnerHTML={{ __html: editorData }} />
      ) : (
        '-ไม่ได้ระบุ-'
      )}

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || formSchema.header}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </>
      )}
    </Panel>
  )
}
